// Handles the display of the alert
export const DISPLAY_CONFIRMATION_ALERT = 'APP/DISPLAY_CONFIRMATION_ALERT'
export const displayConfirmationAlert = ({ title, body }) => ({
  type: DISPLAY_CONFIRMATION_ALERT,
  title,
  body,
})

export const CONFIRMATION_RESOLVED = 'APP/CONFIRMATION_RESOLVED'
export const resolveConfirmation = (resolution) => ({
  type: CONFIRMATION_RESOLVED,
  resolution,
})

const initialConfirmationAlertState = {
  isOpen: false,
  title: '',
  body: '',
}
export const confirmationAlertReducer = (state = initialConfirmationAlertState, action) => {
  switch (action.type) {
    case DISPLAY_CONFIRMATION_ALERT:
      return {
        isOpen: true,
        title: action.title,
        body: action.body,
      }
    case CONFIRMATION_RESOLVED:
      return {
        isOpen: false,
        title: '',
        body: '',
      }
    default:
      return state
  }
}

export const getConfirmationAlert = (state) => state.confirmationAlert
